import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ServiceCard from './ServiceCard';
import ConferenceHall from '../assets/images/Conf_hall_2.jpg';
import DiningImage from '../assets/images/dining_7.jpg';
import BarImage from '../assets/images/Blue_Bar_1.jpg';
import '../styles/services.css';

const Services = ({ language }) => {
  const [apiServices, setApiServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/services`);
        if (Array.isArray(res.data)) {
          setApiServices(res.data);
        } else {
          setApiServices([]);
        }
      } catch (e) {
        setApiServices([]);
      }
    };
    fetchServices();
  }, []);

  const services = [
    {
      title: { en: 'Deluxe Room', am: 'ዴሉክስ ክፍል' },
      description: {
        en: 'Spacious, elegantly furnished rooms with premium bedding, workspace, and city or garden views.',
        am: 'ሰፊ እና በውብ የታጠቁ ክፍሎች፣ ጥራታማ መኝታ እቃ፣ የስራ ቦታ እና የከተማ ወይም የአበባ ቦታ እይታ ጋር።'
      },
      image: '/images/bg1.jpg',
      link: '/rooms/deluxe'
    },
    {
      title: { en: 'Twin Room', am: 'ትዊን ክፍል' },
      description: {
        en: 'Two comfortable twin beds—ideal for friends or colleagues traveling together.',
        am: 'ሁለት ምቹ ትዊን አልጋዎች፣ ከጓደኞች ወይም ከባልደረቦች ጋር ለመጓዝ ተስማሚ።'
      },
      image: '/images/bg2.jpg',
      link: '/rooms/twin'
    },
    {
      title: { en: 'Club Room', am: 'ክለብ ክፍል' },
      description: {
        en: 'A generous king bed with essential amenities for a restful and refreshing stay.',
        am: 'ለማረፍ እና ለማዳነቅ የሚረዱ አስፈላጊ መሳሪያዎች ጋር ሰፊ የኪንግ አልጋ።'
      },
      image: '/images/bg3.jpg',
      link: '/rooms/king'
    },
    {
      title: { en: 'Standard Room', am: 'መደበኛ ክፍል' },
      description: {
        en: 'Well-appointed room with essential amenities for a comfortable and practical stay.',
        am: 'ለምቾት እና ለተግባራዊ መኖሪያ የሚያስፈልጉ አስፈላጊ መሳሪያዎች ያሉት በሚያስደስት ሁኔታ የተዘጋጀ መደበኛ ክፍል።'
      },
      image: '/images/bg2.jpg',
      link: '/rooms/standard'
    },
    {
      title: { en: 'Dining', am: 'ሬስቶራንት' },
      description: {
        en: 'A curated menu of local favorites and international classics served fresh daily.',
        am: 'በየቀኑ በአዲስ የሚቀርቡ አካባቢያዊ እና አለም አቀፍ ምግቦች ጋር የተመረጡ ምናሌዎች።'
      },
      image: DiningImage,
      link: '/dining'
    },
    {
      title: { en: 'Meeting & Events', am: 'ስብሰባ እና ዝግጅቶች' },
      description: {
        en: 'Flexible spaces for board meetings, workshops, and celebrations—supported by our team.',
        am: 'ለየዓይነት ስብሰባዎች እና ዝግጅቶች ተስማሚ ቦታዎች፣ በባለሙያ ቡድናችን የሚደገፉ።'
      },
      image: ConferenceHall,
      link: '/conference'
    },
    {
      title: { en: 'Bar & Lounge', am: 'ባር እና ላውንጅ' },
      description: {
        en: 'Relaxed atmosphere with refreshing beverages and light bites throughout the day.',
        am: 'በቀኑ ሁሉ አሳፋሪ መካከል በዝቅተኛ ድምጽ ቦታ ከማረፍ ጋር የሚሄዱ መጠጦች እና ቀላል ምግቦች።'
      },
      image: BarImage,
      link: '/bar'
    }
  ];

  const normalizedFromApi = Array.isArray(apiServices)
    ? apiServices.map((s) => ({
        title: { en: s.title, am: s.title_am || s.title },
        description: { en: s.description, am: s.description_am || s.description },
        image: s.image ? `${process.env.REACT_APP_API_URL}/uploads/${s.image}` : null,
        link: s.link || '#',
        price: s.price,
      }))
    : [];

  const dataToRender = normalizedFromApi.length ? normalizedFromApi : services;

  return (
    <section className="py-5 services-section" id="services">
      <div className="container">
        <h2 className="text-center mb-2 fw-bold services-title">
          {language === 'en' ? 'Our Services' : 'የእኛ አገልግሎቶች'}
        </h2>
        <div className="services-title-underline mx-auto mb-4"></div>
        <div className="row justify-content-center">
          {dataToRender.map((service, index) => (
            <div
              className="col-md-6 col-lg-4 mb-4"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <ServiceCard
                link={service.link}
                title={service.title[language]}
                description={service.description[language]}
                image={service.image}
                language={language}
                price={service.price}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;